import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcEndpoints = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M19.5 10a.75.75 0 0 0-.75-.75h-6v4.25h-1.5V9.25h-6a.75.75 0 0 0-.75.75v3.5H3V10a2.25 2.25 0 0 1 2.25-2.25h6V3h1.5v4.75h6A2.25 2.25 0 0 1 21 10v3.5h-1.5V10Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M2 15.5a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1H2Zm1.5 2.75a.75.75 0 0 0 0 1.5H4a.75.75 0 0 0 0-1.5h-.5Zm6.75-2.75a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1h-3.5Zm1.5 2.75a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5h-.5Zm5.75-1.75a1 1 0 0 1 1-1H22a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1v-3.5Zm1.75 2.5a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 0 1.5H20a.75.75 0 0 1-.75-.75Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcEndpoints");

export { IcEndpoints };
//# sourceMappingURL=ic-endpoints.js.map
